import { toast } from 'react-toastify';
import { put, select } from 'redux-saga/effects';
import createRequest from '../../../utils/axios';
import * as actionTypes from './timeSlotsActionTypes';

// get all the doctors from backend
export function* getMyTimeSlots(action) {
  const user = yield select((state) => state.homeReducer.user);
  const Axios = yield createRequest();
  try {
    const { data } = yield Axios.get(`doctor/${user._id}`);

    const arry = Object.keys(data.result).sort((a, b) => {
      return new Date(a) - new Date(b);
    });

    yield put({
      type: actionTypes.GET_MY_TIMESLOTS_SUCCESS,
      myTimeSlots: data.result,
    });
    console.log(data);
  } catch (error) {
    yield put({
      type: actionTypes.GET_MY_TIMESLOTS_FAILED,
    });
    toast.error(error.response.data.message);
  }
}

export function* addThisTimeSlot(action) {
  const user = yield select((state) => state.homeReducer.user);
  const Axios = yield createRequest();
  try {
    const { data } = yield Axios.post(
      `doctor/${user._id}/timeslot`,
      action.data
    );
    toast.success('Time slot added successfully');
    yield put({
      type: actionTypes.GET_MY_TIMESLOTS,
    });
    console.log(data);
  } catch (error) {
    toast.error(error.response.data.message);
  }
}

export function* deleteThisTimeSlot(action) {
  const { _id } = action;
  const Axios = yield createRequest();
  try {
    yield Axios.delete(`doctor/timeslot/${_id}`);
    toast.success('Time slot deleted successfully');
    yield put({
      type: actionTypes.GET_MY_TIMESLOTS,
    });
  } catch (error) {
    toast.error('Time slot deleted failed');
  }
}
